<template lang="html">
	<div
		ref="coninput"
		:style="styleLabel"
		:class="[`vs-input-${color}`,{
      'isFocus':isFocus,
      'input-icon-validate-success':success,
      'input-icon-validate-danger':danger,
      'input-icon-validate-warning':warning,
      'is-label-placeholder':labelPlaceholder
    }]"
		class="vs-component vs-con-input-label vs-input">
		<label
			v-if="labelPlaceholder?false:label"
			class="vs-input--label"
			@click="focusInput">{{ label }}</label>
		<div class="vs-con-input">
			<div class="vs-input-row">
				<input type="email" class="vs-con-input__main-cover">
				<input
					ref="vsinput"
					:name="label+value"
					autocomplete="off"
					:style="style"
					:autofocus="autofocus"
					:class="[size,{
					  'hasValue':value !== '',
					  'hasIcon':icon,
					  'icon-after-input':iconAfter
					}]"
					:placeholder="null"
					:value="value"
					v-bind="$attrs"
					readonly
					onfocus="this.removeAttribute('readonly');"
					:type="$attrs.type?$attrs.type:'text'"
					class="vs-inputx vs-input--input"
					v-on="listeners">
				<div
					:class="{ textinput: isPasswordHiddenData }"
					class="vs-input-row__addon"
					@click="toggleShow"
				>
					<vs-button color="primary">
						<svg width="21" height="14.000000000000002" x="0" y="0"
							 class="stencil--easier-to-select">
							<defs></defs>
							<rect x="0" y="0" width="21" height="14.000000000000002"
								  fill="transparent"
								  class="stencil__selection-helper"></rect>
							<path
								d="M10.5 0C5.727272727272727 0 1.6513636363636364 2.9026666666666676 0 7.000000000000001 1.6513636363636364 11.097333333333335 5.727272727272727 14.000000000000004 10.5 14.000000000000004 15.272727272727272 14.000000000000004 19.348636363636366 11.097333333333335 21.000000000000004 7.000000000000001 19.348636363636366 2.9026666666666676 15.272727272727272 0 10.5 0 10.5 0 10.5 0 10.5 0M10.5 11.666666666666668C7.865454545454545 11.666666666666668 5.727272727272727 9.576 5.727272727272727 7.000000000000001 5.727272727272727 4.424 7.865454545454545 2.333333333333334 10.5 2.333333333333334 13.134545454545455 2.333333333333334 15.272727272727272 4.424 15.272727272727272 7.000000000000001 15.272727272727272 9.576 13.134545454545455 11.666666666666668 10.5 11.666666666666668 10.5 11.666666666666668 10.5 11.666666666666668 10.5 11.666666666666668M10.5 4.2C8.915454545454546 4.2 7.636363636363637 5.450666666666668 7.636363636363637 7.000000000000001 7.636363636363637 8.549333333333337 8.915454545454546 9.8 10.5 9.8 12.084545454545454 9.8 13.363636363636363 8.549333333333337 13.363636363636363 7.000000000000001 13.363636363636363 5.450666666666668 12.084545454545454 4.2 10.5 4.2 10.5 4.2 10.5 4.2 10.5 4.2"
								stroke-width="0" stroke="none" stroke-dasharray="none"
								fill="rgb(255, 255, 255)"
								fill-rule="evenOdd"></path>
						</svg>
					</vs-button>
				</div>
			</div>
			<transition name="placeholderx">
        <span
			v-if="isValue&&(labelPlaceholder||$attrs.placeholder)"
			ref="spanplaceholder"
			:style="styleLabel"
			:class="[
            labelPlaceholder&&(size),
            size,
            {
              'vs-placeholder-label': labelPlaceholder,
          }]"
			class="input-span-placeholder vs-input--placeholder"
			@click="focusInput">
          {{ $attrs.placeholder || labelPlaceholder }}
        </span>
			</transition>

			<vs-icon
				v-if="icon"
				:class="{'icon-after':iconAfter, 'icon-no-border':iconNoBorder}"
				:icon-pack="iconPack"
				:icon="icon"
				class="icon-inputx notranslate vs-input--icon"
				@click="focusInput(); $emit('icon-click');">
			</vs-icon>

			<transition name="icon-validate" >
        <span
			v-if="success || danger || warning"
			:class="{'icon-before':iconAfter}"
			class="input-icon-validate vs-input--icon-validate">
          <vs-icon
			  :class="{'icon-before':iconAfter}"
			  :icon-pack="valIconPack"
			  :icon="getIcon"
		  ></vs-icon>
        </span>
			</transition>
		</div>

		<transition-group
			@before-enter="beforeEnter"
			@enter="enter"
			@leave="leave"
		>
			<div
				v-if="success"
				key="success"
				class="con-text-validation vs-input--text-validation">
        <span class="span-text-validation span-text-validation-success vs-input--text-validation-span">
          {{
				successText
			}}
        </span>
			</div>
			<div
				v-else-if="danger"
				key="danger"
				class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
        <span class="span-text-validation">
          {{
				dangerText
			}}
        </span>
			</div>
			<div
				v-else-if="warning"
				key="warning"
				class="con-text-validation span-text-validation-warning vs-input--text-validation-span">
        <span class="span-text-validation">
          {{
				warningText
			}}
        </span>
			</div>
			<div
				v-if="descriptionText"
				key="description"
				class="con-text-validation span-text-validation vs-input--text-validation-span">
        <span class="span-text-validation">
          {{
				descriptionText
			}}
        </span>
			</div>
		</transition-group>



	</div>
</template>

<script>
import _color from '@/assets/utils/color'
export default {
	name:'VsPassword',
	inheritAttrs: false,
	props:{
		value:{
			default:'',
			type:[String,Number]
		},
		labelPlaceholder:{
			default:null,
			type:[String,Number]
		},
		label:{
			default:null,
			type:[String,Number]
		},
		autofocus:{
			default:false,
			type:[Boolean,String]
		},
		icon:{
			default:null,
			type:String
		},
		iconAfter:{
			default:false,
			type:[Boolean,String]
		},
		iconNoBorder:{
			default:false,
			type:Boolean
		},
		iconPack:{
			default:'material-icons',
			type:String
		},
		color:{
			default:'primary',
			type:String
		},
		success:{
			default:false,
			type:Boolean
		},
		danger:{
			default:false,
			type:Boolean
		},
		warning:{
			default:false,
			type:Boolean
		},
		successText:{
			default: null,
			type:String
		},
		dangerText:{
			default: null,
			type:String
		},
		warningText:{
			default: null,
			type:String
		},
		descriptionText:{
			default: null,
			type:String
		},
		size:{
			default:'normal',
			type:String
		},
		valIconPack:{
			default:'material-icons',
			type:String
		},
		valIconSuccess:{
			default: null,
			type:String
		},
		valIconDanger:{
			default: null,
			type:String
		},
		valIconWarning:{
			default: null,
			type:String
		},
		toggleCommand:{
			default: null,
			type:String
		},
		isPasswordHidden:{
			default: false,
			type:Boolean
		}
	},
	inject: {
		elForm: {
			default: ''
		},
		elFormItem: {
			default: ''
		}
	},
	data:()=>({
		isFocus:false,
		isPasswordHiddenData: false,
	}),
	computed:{
		style(){
			return {
				border: `1px solid ${this.isFocus?_color.getColor(this.color,1):'rgba(0, 0, 0,.2)'}`,
			}
		},
		styleLabel(){
			return {
				color: this.isFocus?_color.getColor(this.color,1):null,
			}
		},
		listeners(){
			return {
				...this.$listeners,
				input: (evt) => {
					this.$emit('input',evt.target.value)
				},
				focus: (evt) => {
					this.$emit('focus',evt)
					this.changeFocus(true)
				},
				blur: (evt) => {
					this.$emit('blur',evt)
					this.changeFocus(false)
				}
			}
		},
		isValue(){
			return this.labelPlaceholder?true:!this.value
		},
		getIcon(){
			return this.danger  ? this.valIconDanger
				: this.warning ? this.valIconWarning
					: this.success ? this.valIconSuccess
						: ''
		},
	},
	methods:{
		// animation
		changeFocus(booleanx) {
			this.isFocus = booleanx
		},
		beforeEnter(el) {
			el.style.height = 0
		},
		enter(el, done){
			let h = el.scrollHeight
			el.style.height = h + 'px'
			done()
		},
		leave: function (el) {
			el.style.height = 0 + 'px'
		},
		focusInput(){
			this.$refs.vsinput.focus()
		},
		toggleShow() {
			// this.$emit("toggleShow", this.toggleCommand);
			let input = this.$refs.vsinput;
			this.isPasswordHiddenData = !this.isPasswordHiddenData;
			input.type = input.type === 'password' ? 'text' : 'password';
		}
	},
	created() {
		this.isPasswordHiddenData = this.isPasswordHidden;
	}
}
</script>

<style lang="scss" scoped>
.vs-input-row {
	display: flex;
	width: 100%;

	.vs-input--input {
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
	}

	.vs-con-input {
		&__main-cover {
			position: absolute;
			width: 0;
			height: 0;
			overflow: hidden;
			box-sizing: border-box;
			border: none;
			outline: none;
		}
	}

	.vs-button-text {
		display: flex !important;
		align-items: center;
	}

	&__addon {
		display: flex;

		.vs-button {
			position: relative;
			display: flex;
			align-items: center;
			padding: 0 8px !important;
			border-top-left-radius: 0;
			border-bottom-left-radius: 0;

			&::after {
				content: "";
				position: absolute;
				top: calc(50% - 1.5px);
				left: 10%;
				width: 80%;
				height: 3px;
				border-radius: 5px;
				overflow: hidden;
				background-color: white;
				transform-origin: 50% 50%;
				transform: rotateZ(-45deg);
				opacity: 0;
				transition: opacity 0.2s ease;
			}
		}

		.stencil--easier-to-select {
			display: flex;
			height: 100%;
			transition: opacity 0.2s ease;
		}
	}

	&__addon.textinput {
		.vs-button::after {
			opacity: 1;
		}

		.stencil--easier-to-select {
			opacity: 0.6;
		}
	}
}
</style>
